<template>
  <div>
    <!-- 切换地图 -->
    <ul class="mapSwitch">
      <li
        :class="index === activeIndex ? 'active' : ''"
        v-for="(item, index) in mapSwitchNav"
        @click="mapSwitchClick(index)"
        :key="index"
      >
        <div><img :src="`/image/${index}.png`" alt="" /></div>
        <div>{{ item }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      mapSwitchNav: ["卫星地图", "普通地图", "影像地图"],
      activeIndex: 0,
    };
  },
  computed: {
    ...mapGetters({
      mapSwitch: "switchMap/mapSwitch",
      ip: "ip",
    }),
  },
  methods: {
    ...mapMutations({
      changeMapSwitch: "switchMap/changeMapSwitch",
      changeCurrentMap: "switchMap/changeCurrentMap",
    }),
    mapSwitchClick(index) {
      this.activeIndex = index;
      this.changeMapSwitch(index);
      this.t_switch();
    },
    t_switch() {
      if (this.mapSwitch === 0) {
        map.remove();
        this.$eventBus.$emit("initMap");
      } 
      else if (this.mapSwitch === 1) {
        map.remove();
        this.$eventBus.$emit("initMap");
      }
      else if (this.mapSwitch === 2) {
        map.remove();
        this.$eventBus.$emit("initMap");
      }
    },
  },
  mounted() {
    this.mapSwitchClick(0);
  },
};
</script>

<style lang="less" scoped>
.mapSwitch {
  width: 114px;
  height: 100px;
  position: absolute;
  z-index: 3;
  right: 0px;
  bottom: 100px;
  cursor: pointer;
}
.mapSwitch li {
  overflow: hidden;
  position: absolute;
  float: left;
  width: 114px;
  height: 78px;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;

  div:nth-child(1) {
    height: 53px;
    width: 100%;

    img {
      width: 97%;
      height: 122%;
    }
  }
  div:nth-child(2) {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    width: 100%;
  }
}
.mapSwitch li:nth-child(1) {
  top: 0;
  z-index: 3;
}
.mapSwitch li:nth-child(2) {
  top: 25px;
  z-index: 2;
}
.mapSwitch li:nth-child(3) {
  top: 50px;
  z-index: 1;
}

.mapSwitch li:hover {
  background-color: #1e3250;
  z-index: 31;
}

.active {
  background-color: #1e3250 !important;
  z-index: 30;
}
</style>